import { create } from 'zustand'

interface ContextualUpsellStore {
  isOpen: boolean
  upsell: string | null
  source: string | null
  showContextualUpsell: (upsell: string, source?: string) => void
  hideContextualUpsell: () => void
}

export const useContextualUpsellStore = create<ContextualUpsellStore>(
  (set) => ({
    isOpen: false,
    upsell: null,
    source: null,
    showContextualUpsell: (upsell, source) =>
      set({
        isOpen: true,
        upsell,
        source: source ?? null,
      }),
    hideContextualUpsell: () =>
      set({
        isOpen: false,
        upsell: null,
        source: null,
      }),
  }),
)
